var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetTheSetDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "setthesetdefault-a",
    cx: 16,
    cy: 16,
    r: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "setthesetdefault-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#setthesetdefault-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#39A4A1",
    xlinkHref: "#setthesetdefault-a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#setthesetdefault-b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M26.333 26.834a39.426 39.426 0 01-14.769 4.734 21.715 21.715 0 0011.898-6.76c1.956 2.416 2.871 2.026 2.871 2.026z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105568",
    d: "M5.353 6.186v25.358s5.226.135 6.244.024c1.017-.11 6.248-.673 11.897-6.76 0 0 1.961 3.388 2.872 2.026 0 0 .373-3.196.193-20.456L5.353 6.186z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.685 16.897a3.056 3.056 0 10-6.105.312 3.056 3.056 0 006.105-.312zm-1.411.386L9.84 18.81a.328.328 0 01-.324-.332l.045-2.872a.328.328 0 01.332-.324l2.388 1.616a.21.21 0 01-.008.382v.004zM9.97 5.926l11.672-.683.146 2.481-11.672.684zM15.441 15.201h7.815v-.726h-7.815zm0 2.211h7.815v-.726h-7.815zm0 2.212h7.815v-.727h-7.815z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetTheSetDefault);
export default __webpack_public_path__ + "static/media/SetTheSetDefault.385e578f.svg";
export { ForwardRef as ReactComponent };